import React from 'react';
import { Image } from 'react-bootstrap';
import Button from '../Shared/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/CancelModal.css';
import success from '../../Assets/TruckVisits/Assets-Desktop/alert.svg';
import RespModal from '../Shared/RespModal';

function CancelModal(props) {
    return(
        <RespModal hasOpen={props.hasOpen}  >
        <div className="modalsize" >
            <Image src={success} /><br /><br />
            <div id="modalcontainsuccess">
                 {props.children}
            </div>
            <div class="cancelresploginbuttonouter">
            <Button
                id="cancelresploginbutton"
                type="button"
                class="btn btn-dark"
                onClick={props.onYesModal}
            >Yes
        </Button>
        <Button
                id="cancelresploginbutton"
                type="button"
                class="btn btn-dark"
                onClick={props.onCloseModal}
            >No
        </Button>
            </div>
        <br /><br />
        </div>
    </RespModal>
    );
}
export default CancelModal;